module.exports = __webpack_public_path__ + "img/mono_30.50074cbd.png";